<div class="container mx-auto px-4 py-6">

  <!-- Header -->
  <div class="mb-6 flex items-center justify-between">
    <div>
      <h1 class="text-3xl font-bold text-gray-800">🎟️ Cupons Promocionais</h1>
      <p class="text-gray-600 mt-1">Gestão de cupons de desconto</p>
    </div>
    <button (click)="openCreate()"
      class="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition font-medium">
      + Novo Cupom
    </button>
  </div>

  <!-- Filters -->
  <div class="bg-white rounded-lg shadow p-4 mb-6">
    <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Buscar por código</label>
        <input [(ngModel)]="search" type="text" placeholder="Ex: PROMO20"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Status</label>
        <select [(ngModel)]="statusFilter"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
          <option value="">Todos</option>
          <option value="active">✅ Ativos</option>
          <option value="expired">⏳ Expirados</option>
        </select>
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Tipo de Desconto</label>
        <select [(ngModel)]="typeFilter"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
          <option value="">Todos</option>
          <option value="percentage">% Percentual</option>
          <option value="fixed">R$ Valor Fixo</option>
        </select>
      </div>
      <div class="flex items-end gap-2">
        <button (click)="load()"
          class="flex-1 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition">
          🔍 Filtrar
        </button>
        <button (click)="resetFilters()"
          class="flex-1 px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50 transition">
          ✕ Limpar
        </button>
      </div>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="flex justify-center items-center py-12">
    <app-spinner></app-spinner>
  </div>

  <!-- Coupon list -->
  <div *ngIf="!loading" class="bg-white rounded-lg shadow overflow-hidden">
    <div class="overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Código</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Desconto</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Usos</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Validade</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ações</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr *ngFor="let c of items" class="hover:bg-gray-50 transition">
            <!-- Code -->
            <td class="px-6 py-4">
              <div class="font-mono text-sm font-bold text-gray-900 tracking-wider">{{ c.code }}</div>
              <div *ngIf="c.description" class="text-xs text-gray-500 mt-0.5">{{ c.description }}</div>
            </td>
            <!-- Discount -->
            <td class="px-6 py-4">
              <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                [ngClass]="c.discountType === 'percentage' ? 'bg-blue-100 text-blue-800' : 'bg-purple-100 text-purple-800'">
                {{ c.discountType === 'percentage' ? c.discountValue + '%' : 'R$ ' + (c.discountValue | number:'1.2-2') }}
              </span>
              <div *ngIf="c.minPurchaseAmount" class="text-xs text-gray-500 mt-1">
                Mín: R$ {{ c.minPurchaseAmount | number:'1.2-2' }}
              </div>
            </td>
            <!-- Uses -->
            <td class="px-6 py-4">
              <div class="text-sm text-gray-900">
                {{ c.currentUses }}{{ c.maxUses ? ' / ' + c.maxUses : '' }}
              </div>
              <div *ngIf="c.maxUses" class="mt-1 w-24">
                <div class="bg-gray-200 rounded-full h-1.5">
                  <div class="bg-blue-500 h-1.5 rounded-full"
                    [style.width.%]="getUsagePercent(c)"></div>
                </div>
                <div class="text-xs text-gray-500 mt-0.5">{{ getUsagePercent(c) }}%</div>
              </div>
              <div *ngIf="!c.maxUses" class="text-xs text-gray-500">Ilimitado</div>
            </td>
            <!-- Expiry -->
            <td class="px-6 py-4 whitespace-nowrap">
              <div class="text-sm" [ngClass]="isExpired(c) ? 'text-red-600 font-medium' : 'text-gray-900'">
                {{ c.expiresAt | date:'dd/MM/yyyy' }}
              </div>
              <div *ngIf="isExpired(c)" class="text-xs text-red-500">Expirado</div>
            </td>
            <!-- Status -->
            <td class="px-6 py-4">
              <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full"
                [ngClass]="(c.isActive && !isExpired(c)) ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'">
                {{ (c.isActive && !isExpired(c)) ? '✅ Ativo' : '❌ Inativo' }}
              </span>
            </td>
            <!-- Actions -->
            <td class="px-6 py-4 whitespace-nowrap text-sm font-medium space-x-2">
              <button (click)="openEdit(c)" class="text-blue-600 hover:text-blue-900" title="Editar">✏️ Editar</button>
              <button (click)="viewUsage(c)" class="text-indigo-600 hover:text-indigo-900" title="Ver uso">📊 Uso</button>
              <button (click)="remove(c)" class="text-red-600 hover:text-red-900" title="Remover">🗑️</button>
            </td>
          </tr>
          <tr *ngIf="items.length === 0">
            <td colspan="6" class="px-6 py-12 text-center text-gray-500">
              <div class="text-4xl mb-2">🎟️</div>
              <p>Nenhum cupom encontrado</p>
              <button (click)="openCreate()" class="mt-3 text-blue-600 hover:underline text-sm">Criar primeiro cupom</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination info -->
    <div *ngIf="total > 0" class="bg-white px-4 py-3 border-t border-gray-200 sm:px-6">
      <div class="flex items-center justify-between">
        <p class="text-sm text-gray-700">
          Mostrando <span class="font-medium">{{ (page - 1) * pageSize + 1 }}</span>
          até <span class="font-medium">{{ displayEnd() }}</span>
          de <span class="font-medium">{{ total }}</span> resultado{{ total !== 1 ? 's' : '' }}
        </p>
        <app-pagination [page]="page" [pageSize]="pageSize" [total]="total"
          (pageChange)="onPageChange($event)"></app-pagination>
      </div>
    </div>
  </div>
</div>

<!-- ===== Create/Edit Modal ===== -->
<div *ngIf="showFormModal" class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
  <div class="bg-white rounded-lg shadow-xl w-full max-w-lg max-h-[90vh] overflow-y-auto">
    <div class="px-6 py-4 border-b border-gray-200 flex items-center justify-between">
      <h2 class="text-xl font-semibold text-gray-800">
        {{ editingItem ? '✏️ Editar Cupom' : '🎟️ Novo Cupom' }}
      </h2>
      <button (click)="closeFormModal()" class="text-gray-400 hover:text-gray-600 text-2xl leading-none">&times;</button>
    </div>

    <form [formGroup]="form" (ngSubmit)="save()" class="px-6 py-4 space-y-4">

      <!-- Code -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">
          Código do Cupom <span class="text-red-500">*</span>
        </label>
        <input formControlName="code" type="text" maxlength="20"
          (input)="onCodeInput($event)"
          placeholder="Ex: PROMO20"
          class="w-full px-3 py-2 border border-gray-300 rounded-md font-mono uppercase focus:outline-none focus:ring-2 focus:ring-blue-500"
          [ngClass]="{'border-red-500': form.get('code')?.invalid && form.get('code')?.touched}">
        <p class="text-xs text-gray-500 mt-1">Apenas letras maiúsculas, números e hífen. Máx. 20 caracteres.</p>
        <p *ngIf="form.get('code')?.invalid && form.get('code')?.touched" class="text-xs text-red-500 mt-1">
          Código inválido
        </p>
      </div>

      <!-- Description -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Descrição Interna</label>
        <textarea formControlName="description" rows="2" maxlength="200"
          placeholder="Descrição interna para controle"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"></textarea>
        <p class="text-right text-xs text-gray-400">{{ form.get('description')?.value?.length || 0 }}/200</p>
      </div>

      <!-- Discount Type -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">
          Tipo de Desconto <span class="text-red-500">*</span>
        </label>
        <div class="flex gap-4">
          <label class="flex items-center gap-2 cursor-pointer">
            <input type="radio" formControlName="discountType" value="percentage" class="text-blue-600">
            <span class="text-sm">Percentual (%)</span>
          </label>
          <label class="flex items-center gap-2 cursor-pointer">
            <input type="radio" formControlName="discountType" value="fixed" class="text-blue-600">
            <span class="text-sm">Valor Fixo (R$)</span>
          </label>
        </div>
      </div>

      <!-- Discount Value -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">
          Valor do Desconto <span class="text-red-500">*</span>
        </label>
        <div class="relative">
          <span class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm">
            {{ form.get('discountType')?.value === 'percentage' ? '%' : 'R$' }}
          </span>
          <input formControlName="discountValue" type="number" min="0.01" step="0.01"
            class="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            [ngClass]="{'border-red-500': form.get('discountValue')?.invalid && form.get('discountValue')?.touched}">
        </div>
        <p *ngIf="form.get('discountValue')?.invalid && form.get('discountValue')?.touched" class="text-xs text-red-500 mt-1">
          Informe um valor válido
        </p>
      </div>

      <!-- Expiry Date -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">
          Data de Validade <span class="text-red-500">*</span>
        </label>
        <input formControlName="expiresAt" type="date"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          [ngClass]="{'border-red-500': form.get('expiresAt')?.invalid && form.get('expiresAt')?.touched}">
        <p *ngIf="form.get('expiresAt')?.invalid && form.get('expiresAt')?.touched" class="text-xs text-red-500 mt-1">
          Informe a data de validade
        </p>
      </div>

      <!-- Max Uses -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Limite de Usos</label>
        <input formControlName="maxUses" type="number" min="1" placeholder="Deixe em branco para ilimitado"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
        <p class="text-xs text-gray-500 mt-1">Deixe vazio para usos ilimitados</p>
      </div>

      <!-- Min Purchase -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Compra Mínima (R$)</label>
        <input formControlName="minPurchaseAmount" type="number" min="0" step="0.01" placeholder="Opcional"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
      </div>

      <!-- Active toggle (edit only) -->
      <div *ngIf="editingItem" class="flex items-center gap-3">
        <input formControlName="isActive" type="checkbox" id="isActive"
          class="h-4 w-4 text-blue-600 rounded border-gray-300">
        <label for="isActive" class="text-sm font-medium text-gray-700">Cupom ativo</label>
      </div>

      <!-- Actions -->
      <div class="pt-2 flex justify-end gap-3 border-t border-gray-100">
        <button type="button" (click)="closeFormModal()"
          class="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50 transition text-sm">
          Cancelar
        </button>
        <button type="submit" [disabled]="form.invalid || saving"
          class="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition text-sm disabled:opacity-60 disabled:cursor-not-allowed">
          {{ saving ? 'Salvando...' : (editingItem ? 'Atualizar' : 'Criar Cupom') }}
        </button>
      </div>
    </form>
  </div>
</div>

<!-- ===== Usage Modal ===== -->
<div *ngIf="showUsageModal" class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
  <div class="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
    <div class="px-6 py-4 border-b border-gray-200 flex items-center justify-between">
      <h2 class="text-xl font-semibold text-gray-800">📊 Uso do Cupom</h2>
      <button (click)="closeUsageModal()" class="text-gray-400 hover:text-gray-600 text-2xl leading-none">&times;</button>
    </div>

    <div class="px-6 py-4">
      <!-- Loading usage -->
      <div *ngIf="loadingUsage" class="py-8 text-center">
        <app-spinner></app-spinner>
      </div>

      <!-- Usage data -->
      <div *ngIf="!loadingUsage && usageData">
        <!-- Stats -->
        <div class="grid grid-cols-3 gap-4 mb-6">
          <div class="bg-blue-50 rounded-lg p-3 text-center">
            <div class="text-2xl font-bold text-blue-800">{{ usageData.currentUses }}</div>
            <div class="text-xs text-blue-600">Usos Totais</div>
          </div>
          <div class="bg-gray-50 rounded-lg p-3 text-center">
            <div class="text-2xl font-bold text-gray-800">{{ usageData.maxUses || '∞' }}</div>
            <div class="text-xs text-gray-600">Limite</div>
          </div>
          <div class="bg-green-50 rounded-lg p-3 text-center">
            <div class="text-2xl font-bold text-green-800">{{ usageData.usagePercentage | number:'1.0-0' }}%</div>
            <div class="text-xs text-green-600">Utilização</div>
          </div>
        </div>

        <!-- Progress bar -->
        <div *ngIf="usageData.maxUses" class="mb-6">
          <div class="flex justify-between text-xs text-gray-500 mb-1">
            <span>0</span>
            <span>{{ usageData.maxUses }}</span>
          </div>
          <div class="bg-gray-200 rounded-full h-2">
            <div class="bg-blue-500 h-2 rounded-full transition-all"
              [style.width.%]="usageData.usagePercentage"></div>
          </div>
        </div>

        <!-- Recent usages -->
        <div>
          <h3 class="text-sm font-semibold text-gray-700 mb-3">Usos Recentes</h3>
          <div *ngIf="usageData.recentUsages?.length === 0" class="text-sm text-gray-500 text-center py-4">
            Nenhum uso registrado ainda
          </div>
          <div *ngIf="(usageData.recentUsages?.length ?? 0) > 0" class="overflow-x-auto">
            <table class="min-w-full text-sm">
              <thead>
                <tr class="bg-gray-50">
                  <th class="px-3 py-2 text-left text-xs font-medium text-gray-500">Fornecedor</th>
                  <th class="px-3 py-2 text-left text-xs font-medium text-gray-500">Data</th>
                  <th class="px-3 py-2 text-right text-xs font-medium text-gray-500">Valor</th>
                  <th class="px-3 py-2 text-right text-xs font-medium text-gray-500">Desconto</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-100">
                <tr *ngFor="let u of usageData.recentUsages" class="hover:bg-gray-50">
                  <td class="px-3 py-2">{{ u.supplierName }}</td>
                  <td class="px-3 py-2">{{ u.usedAt | date:'dd/MM/yyyy HH:mm' }}</td>
                  <td class="px-3 py-2 text-right">R$ {{ u.orderAmount | number:'1.2-2' }}</td>
                  <td class="px-3 py-2 text-right text-green-600">-R$ {{ u.discountAmount | number:'1.2-2' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- No data -->
      <div *ngIf="!loadingUsage && !usageData" class="py-8 text-center text-gray-500">
        <div class="text-3xl mb-2">📭</div>
        <p>Dados de uso não disponíveis</p>
      </div>
    </div>

    <div class="px-6 py-3 border-t border-gray-100 text-right">
      <button (click)="closeUsageModal()"
        class="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50 text-sm">
        Fechar
      </button>
    </div>
  </div>
</div>
